'use client';

import { useStore } from 'zustand';

import { authStore } from '@/store/auth.store';
import { useRequireAuthentication } from '@/hooks/use-require-authentication.hook';

export function useProtectedRoute() {
  const authStatus = useStore(authStore, (state) => state.authStatus);
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const isAuthReady = authStatus !== 'loading';

  useRequireAuthentication(isAuthReady && !isLoggedIn);

  return { isLoggedIn, isAuthReady };
}
